import { TimeTracker, throttle } from 'mpfe-utils'

export default function reportReadDuration(opts) {
    const secureScore = opts.secureScore
    const hiddenRatio = opts.hiddenRatio

    let _height = document.documentElement.clientHeight
    let _readingRatio = 0

    window.TIMETRACKER = new TimeTracker()
    window.TIMETRACKER.setPageState({
        showRatio: `${100 - Number(hiddenRatio)}%`,
    })

    // 通用的计算阅读比例方法
    const getReadingProgress = () => {
        const article = document.querySelector('.article')
        if (!article) return 0

        // 当前阅读位置 = 视窗高度 + 滚动位置 - 文章顶部位置
        const scrollPosition = _height + window.scrollY - article.offsetTop
        // 文章总高度（展开前后会自动变化）
        const articleHeight = article.offsetHeight

        // 返回阅读比例（0~1）
        return Math.min(scrollPosition, articleHeight) / articleHeight
    }

    // 滚动处理函数（统一处理展开前后状态）
    const handleScroll = () => {
        if (_readingRatio === 1) return

        const newRatio = getReadingProgress()
        console.log('阅读时长', newRatio)
        // 只有比例增加时才更新
        if (newRatio > _readingRatio) {
            _readingRatio = newRatio
            window.TIMETRACKER.setPageState({
                ratio: `${(_readingRatio * 100).toFixed(2)}%`,
            })

            // 读到100%时立即上报
            if (_readingRatio >= 0.999) {
                // 用0.999避免浮点数精度问题
                _readingRatio = 1
                window.TIMETRACKER.reportPageState()
            }
        }
    }

    // 监听展开事件
    if (secureScore == 24 && hiddenRatio != 0) {
        window.EVENT_BUS.$on('lookAll', () => {
            // 更新展示比例状态
            window.TIMETRACKER.setPageState({
                showRatio: '100%',
            })
            _readingRatio = 0 // 比例重置为0即可
        })
    }

    window.addEventListener('scroll', throttle(handleScroll, 100))
}
